import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Supabase configuration
// These should be set as environment variables in Vercel
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Only create client if we have valid credentials
// This prevents crashes when env vars aren't set
export const supabase: SupabaseClient | null = 
  supabaseUrl && supabaseAnonKey 
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;

if (!supabase) {
  console.warn('Supabase URL or Anon Key is missing. Waitlist submissions will not work until configured.');
}

